import { VIDEO_TYPE } from "configs/jobs/constants";
import { useCallback } from "react";
import { isIOS, osVersion } from "react-device-detect";
import { Question } from "types/store/candidateAnswer.ts";

type NavigationProps = {
  userId: string;
  jobId: string;
  questions: Question[];
  currentAction: string;
  saveCurrentQuestion: (params: { userId: string; questionCurrentCashed: null }) => void;
  setCashedElapsingTime: (time: null) => void;
  updateFirebaseData?: () => void;
  history: {
    push: (path: { pathname: string }) => void;
  };
};

const useStepperNavigation = ({
  userId,
  jobId,
  questions,
  currentAction,
  saveCurrentQuestion,
  setCashedElapsingTime,
  updateFirebaseData,
  history
}: NavigationProps) => {
  const goToNextQuestion = useCallback((questionId: string) => {
    saveCurrentQuestion({ userId, questionCurrentCashed: null });
    setCashedElapsingTime(null);

    const questionNumber = questions.findIndex(item => item.key === questionId);

    const question = questions.find(item => item.key === questionId);

    if (typeof updateFirebaseData === "function") {
      updateFirebaseData();
    }

    history.push({
      pathname: `/candidate/video-questions/${currentAction}/${userId}/${jobId}/${questionId}/${questionNumber}`
    });

    // eslint-disable-next-line camelcase
    if (isIOS && parseFloat(osVersion) >= 18.0 && question?.answer_type === VIDEO_TYPE) {
      window.location.reload();
    }
  }, [
    currentAction,
    history,
    jobId,
    questions,
    saveCurrentQuestion,
    setCashedElapsingTime,
    updateFirebaseData,
    userId
  ]);

  return { goToNextQuestion };
};

export default useStepperNavigation;
